import { toast } from '@/shared/lib';
import { exportPDF, exportPNG, type ExportTarget, type SetStatus } from '../lib/export';

// "Download PDF" (the page's one yellow button) and "Download PNG", for the top bar. What happens is told in a toast at the
// bottom of the screen: green while working and when done, red when it can't be done.
export function ExportButtons({ target, pdfNote }: { target: () => ExportTarget; pdfNote: string }) {
  const say: SetStatus = (msg, cls = '') => toast(msg, cls === '', cls === 'ok' && msg.includes('print dialog') ? 6000 : undefined);
  return (
    <>
      <button type="button" className="btn" onClick={() => exportPDF(target(), say)}>↓ Download PDF<span className="sr-only"> ({pdfNote})</span></button>
      <button type="button" className="btn ghost" onClick={() => exportPNG(target(), say)}>↓ Download PNG</button>
    </>
  );
}
